import { useSpinToWin } from 'features';
import { LandingPage } from './LandingPage';
import { ResultsPage } from './ResultsPage';
import { Fade } from '@telescope/cassini-ui';
import { Text, AdUnit, AdUnitSize } from 'components';
import { useWidget } from '@telescope/cassini-hooks';
import { SpinTheWheelOpen } from 'types';

export const SpinTheWheelGame = () => {
  const { displayResults } = useSpinToWin();

  const { data: rulesData } = 
    useWidget({ select: (data: SpinTheWheelOpen) => data.widget.global_views.rules });
  const { content: { faqsDescription } } = rulesData!;

  const { data } = useWidget({ select: (data: SpinTheWheelOpen) => data.snapshot.snapshot_views.landing });
  const { content } = data!;

  return (
    <>
      <Fade in={!displayResults} transition={{ exit: { duration: 0.2 } }} unmountOnExit={true}>
        <LandingPage />
      </Fade>
      
      <Fade in={displayResults} transition={{ enter: { delay: 0.2, duration: 0.3 } }} unmountOnExit={true}>
        <ResultsPage />
      </Fade>

      <Text allowMarkdown={true} mb={5}>
        {content.bottomDescription}
      </Text>

      <Text allowMarkdown={true} align="center" fontWeight="semibold">
        {faqsDescription}
      </Text>
    </>
  )
}